import { COLORS } from "@/app/common/consts/colors";
import React from "react";
import type { IconProps } from "./type";

const ArrowUp = ({ color = "lightblack" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M16 6.66634L24 14.6663M16 6.66634L8 14.6663M16 6.66634L16 25.333"
        stroke={COLORS[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowUp;
